export default "__VITE_ASSET__BqUS2Zpb__"